import React from "react";
import { Box, Card } from "@mui/material";
import LinesDecor from "../../components/LinesDecor";

export default function MapSection() {
  return (
    <>
    <Box sx={{ position: "relative", width: "100%", mt: 5 }}>
      {/* Map Card */}
      <Card 
        elevation={3}
        sx={{ 
          width: "100%", 
          height: "500px", 
          overflow: "hidden",
          
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box sx={{ width: "100%", height: "100%" }}>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2280.316789723288!2d120.35624328429708!3d16.012452047205816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x339143af2ddbf549%3A0x7fa187faf10503bc!2sRRF%20Building!5e0!3m2!1sen!2sph!4v1765516087333!5m2!1sen!2sph" 
            title="Centrum Fuel Location Map"
            width="100%"
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen=""    
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade" 
          >
          </iframe>
        </Box>
      </Card>
       <Box sx={{ position: "Relative", width: "100%",}}>
         <LinesDecor
            greenMt={{ xl: -5, lg: -5, md: -4, sm: -2, xs: 1 }}
            blueMt={{ xl: 0, lg: 1, md: 2, sm: 1, xs: 3 }}/>
        </Box>
    </Box>
   
  </>
  );
}